export interface MaxSnackbarOptions {
    time?: number;
    color?: string;
    backgroundColor?: string;
    width?: string;
    fontSize?: string;
}

export const MaxSnackbar = {
    show: (text: string, options?: MaxSnackbarOptions) => {
        const defaults = {
            time: 2000,
            color: '#fff',
            backgroundColor: '#333',
            width: '250px',
            fontSize: '1.5rem'
        };

        Object.assign(defaults, options);

        const snackbar = document.createElement('div');
        snackbar.style.display = 'flex';
        snackbar.style.justifyContent = 'center';
        snackbar.style.borderRadius = '15px';
        snackbar.style.minWidth = defaults.width;
        snackbar.style.backgroundColor = defaults.backgroundColor;
        snackbar.style.color = defaults.color;
        snackbar.style.textAlign = 'center';
        snackbar.style.padding = '5px';
        snackbar.style.position = 'fixed';
        snackbar.style.zIndex = '999';
        snackbar.style.left = '50%';
        snackbar.style.transform = 'translateX(-50%)';
        snackbar.style.bottom = '30px';
        snackbar.style.transition = 'opacity 0.3s';
        snackbar.style.opacity = '0';
        snackbar.style.fontSize = defaults.fontSize;
        snackbar.innerText = text;

        document.body.appendChild(snackbar);
        setTimeout(() => {
            snackbar.style.opacity = '1';
        }, 0);

        setTimeout(() => {
            snackbar.style.opacity = '0';
            setTimeout(() => {
                snackbar.remove();
            }, 300);
        }, defaults.time);
    }
};
